var l="@hpstellar/pdp/gallerycarousel";export{l as galleryTestId};
